
var sprite = require("/data/src/node_modules/svg-sprite-loader/lib/web/global-sprite");
var image = "<symbol viewBox=\"0 0 40 40\" id=\"tab-boon-icon\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"> <path d=\"M25.7,7.8v12.9l-0.3-0.2l-1.3-0.8l-1.3,0.8l-0.3,0.2V7.8H25.7 M28.2,5.3H20v19.8l4.1-2.5l4.1,2.5V5.3L28.2,5.3z\"/> <path d=\"M30.7,17.7v16c0,0.3-0.2,0.5-0.5,0.5H9.8c-0.3,0-0.5-0.2-0.5-0.5v-16H6.8v16c0,1.7,1.4,3,3,3h20.4c1.7,0,3-1.3,3-3v-16H30.7\n\tz\"/> <path d=\"M33.5,5.3h-27c-1.6,0-3,1.4-3,3v6.3c0,1.7,1.4,3,3,3h16v-2.5h-16c-0.3,0-0.5-0.2-0.5-0.5V8.3c0-0.3,0.2-0.5,0.5-0.5h27\n\tc0.3,0,0.5,0.2,0.5,0.5v6.3c0,0.3-0.2,0.5-0.5,0.5h-6.8v2.5h6.8c1.7,0,3-1.3,3-3V8.3C36.5,6.7,35.1,5.3,33.5,5.3z\"/> </symbol>";
module.exports = sprite.add(image, "tab-boon-icon");


//////////////////
// WEBPACK FOOTER
// ./src/icons/tab-boon-icon.svg
// module id = 377
// module chunks = 36